import isNumber from './is-number';
/**
 * 判断值是否为小数
 * @return 是否为小数
 */
export default function isDecimal(num) {
    return isNumber(num) && num % 1 !== 0;
}
//# sourceMappingURL=is-decimal.js.map